/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![LeagueOfLegendsBrandIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB4klEQVR4nMWVv2sUURDHn0HEEAgBg2BCAgGrEFNK0GLB7Eyul3QqpIj5C0QQ4ZqgxsbSRrIze1xzqdKlCByCmER2Zq9IowQtbERQVCSIRU7mboUzub29vRz4hSkeb9589u38eM79DwnBihDe/8d44Xb/AAHeVMb6MdvpG6ABYdxoB4gCf64WwlS97s6cCqCEa+0AyvjN1kLwUQmeRaWFS/0FkP9ACMrC8LkJwp9CeDdX8P3K4rk0QKuPBRaGLw0Q4yPXjYRwSagwmwX4K8uHMhw0fAjvuE6Kyt6oMPzIAzBJiJeb5+BrHHgjLk1KsGrBaiHM5AGYYoZ7SfIfujQJ4zsh/FStemfzAnZLhWFh+KWMUfvgL/yx5n+E0NZ5ASZlfCmER68rc4PuuDTEa63V0AtACAPzfbOOEyc2Y8KrSSWsnQJA5hvTjfETm0ZNGqfSM4DxlTVevVgcSHGAD0rwvRp45/MC9nj+gjL+VsKtTld82rxFvj4wKWExKdNbLk21EC720mjRun9FCQ+F8K2NEJf1FiQHugbEAVyPQ1jUUmHadSOb9UrwvBUghO8bwy3DYsblWghDHQER+5NWDW1etUyzPGbeQBk3ewmujNs2Zjp/fdkbVYYneU0IHlupdpWDfuoPoShW5oI5VigAAAAASUVORK5CYII=)
 */
export const LeagueOfLegendsBrandIcon = ({size = 'md', width, height, ...props}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill="#CEA146"
        d="M10.78 1.5v18.08h10.5l-2.34 2.92H4.71l1.75-2.92V3.6L4.94 1.5h5.84Zm1.28 3.97a7.5 7.5 0 0 1 5.13 12.83h2.22a10.07 10.07 0 0 0 1.75-5.25 9.16 9.16 0 0 0-9.1-9.33v1.75ZM5.18 16.08a6.95 6.95 0 0 1-.7-3.15c0-1.16.23-2.21.7-3.15V6.75a9.81 9.81 0 0 0-2.45 6.07c0 2.45.81 4.66 2.45 6.3v-3.04Z"
      />
    </svg>
  );
};
